// extracted by mini-css-extract-plugin
export default {"resource-content-threads":"resource-content-threads__ANEsB","threads":"threads__3nyZ_","summary":"summary__14TsJ"};